import { SentryAppRoot } from '@/js/shared/sentryClient';
import {
  EventEmitterContext,
  useEventEmitterInstance,
} from '@byteclaw/use-event-emitter';
import { CssBaseline } from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { AnnouncementProvider } from '@/js/shared/components/ui/AnnouncementProvider';

import themeCoeo from '@/js/themes/coeo_live';
import SiteRoutes from '@/routes/participant/SiteRoutes';
import { Coeolytics } from '@/lib/utils/coeolytics';

import { ConferencePagesProvider } from '@/store';
import {
  AuthContextProvider,
  ConferenceContextProvider,
  DiscussionContextProvider,
  MenuContextProvider,
  PusherContextProvider,
  ThreadContextProvider,
  UserContextProvider,
  VideoChatContextProvider,
  CoeolyticsProvider,
} from '@/store';

const App = () => {
  const eventEmitter = useEventEmitterInstance();
  const coeoLytics = Coeolytics();
  coeoLytics.page();
  return (
    <ThemeProvider theme={themeCoeo}>
      <AnnouncementProvider>
        <CoeolyticsProvider instance={coeoLytics}>
          <EventEmitterContext.Provider value={eventEmitter}>
            <AuthContextProvider>
              <UserContextProvider>
                <ThreadContextProvider>
                  <DiscussionContextProvider>
                    <PusherContextProvider>
                      <VideoChatContextProvider
                        videoChatEnabled={window.SETTINGS.USE_VIDEOCHAT}
                      >
                        <ConferenceContextProvider
                          useSnackbar
                          conferencename={window.CONFERENCE_NAME}
                        >
                          <MenuContextProvider>
                            <CssBaseline />
                            <ConferencePagesProvider>
                              <SiteRoutes />
                            </ConferencePagesProvider>
                          </MenuContextProvider>
                        </ConferenceContextProvider>
                      </VideoChatContextProvider>
                    </PusherContextProvider>
                  </DiscussionContextProvider>
                </ThreadContextProvider>
              </UserContextProvider>
            </AuthContextProvider>
          </EventEmitterContext.Provider>
        </CoeolyticsProvider>
      </AnnouncementProvider>
    </ThemeProvider>
  );
};

const container = document.getElementById('app');
const root = createRoot(container);
root.render(
  <SentryAppRoot>
    <App />
  </SentryAppRoot>
);
